import Banner from "~/ui-rtk/components/ui/common/Banner"
import { brandRoutes } from "~/ui-rtk/constants/routes"
import { CompanyTier } from "~/ui-rtk/api/types"
import useAccess from "~/ui-rtk/hooks/access"
import useCurrentCompany from "~/ui-rtk/hooks/current-company"

/**
 * Super-admin-only notice that the current company is STALE: it aged out
 * without a paid subscription, so its regular users see the paywall instead
 * of the app (APP-508). Super admins keep the full app to inspect it, which
 * is also why nothing else on screen says the company is paywalled. A new
 * Stripe subscription restores it on its own; the manual restore is the same
 * upgrade button as for SOS_FREE (Settings > Company > Company Tier).
 */
export default function StaleTierAdminAlert() {
  const { isSuperAdmin } = useAccess()
  const currentCompany = useCurrentCompany()

  if (!isSuperAdmin || currentCompany?.tier !== CompanyTier.STALE) {
    return null
  }

  return (
    <Banner
      title={`${currentCompany.name} is a STALE (paywalled) company`}
      variant="danger"
      link={{
        to: brandRoutes.SETTINGS.COMPANY,
        label: "Open Company Settings to restore",
      }}
    >
      This company aged out without a paid subscription, so its users see the
      paywall instead of the app and no data is served to them. A new Stripe
      subscription restores it automatically; to restore it by hand, upgrade it
      to STANDARD.
    </Banner>
  )
}
